import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('fragment', [_vm.label ? _c('Label', _vm._b({
    attrs: {
      "html-for": _vm.id,
      "bold": _vm.labelBold,
      "disabled": _vm.disabled
    }
  }, 'Label', _vm.labelProps, false), [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c('b-dropdown', {
    staticClass: "select",
    class: _vm.inputClass,
    attrs: {
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.placeholderValue) + " "), _c('ChevronUp', {
          staticClass: "icon-dropdown-select",
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }])
  }, _vm._l(_vm.options, function (option) {
    return _c('b-dropdown-item-button', {
      key: option.value,
      on: {
        "click": function click($event) {
          return _vm.updateValue(option.value);
        }
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  }), 1), _vm.description ? _c('div', {
    staticClass: "input-description input-margin",
    class: _vm.descriptionClass
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };